import { FC, memo } from 'react'
import { useNavigate } from 'react-router-dom'
import { FastConvert } from 'store/convert/hooks'
import { ConvertIcon } from 'components/ConvertIcon'
import { MarketIconWrap, PairColumn, SymbolRow } from './style'
import Iconfont from 'components/Iconfont'
import { useMarketDrawer } from 'components/MarketDrawer'

export const ConvertItem: FC<{
  item: FastConvert
}> = memo(({ item }) => {
  const navigate = useNavigate()
  const { close: closeDrawer } = useMarketDrawer()
  return (
    <SymbolRow
      onClick={() => {
        navigate(`/convert/${item.baseName}/${item.quoteName}`)
        closeDrawer()
      }}
    >
      <PairColumn>
        <MarketIconWrap>
          <img src={item.icon} alt="" />
          <ConvertIcon />
        </MarketIconWrap>
        {`${item.baseName}/${item.quoteName}`}
        <Iconfont name="icon-ArrowRight" size={12} />
      </PairColumn>
    </SymbolRow>
  )
})
